import React from "react";
import styles from "./IconButton.module.css";

/**
 * `danger` is the default so every existing call site keeps the red it was written against.
 * Reach for `primary` when the action is additive rather than destructive.
 */
type IconButtonVariant = "danger" | "primary" | "neutral";

interface Props
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  label?: string;
  stopPropagation?: boolean;
  variant?: IconButtonVariant;
}

export const IconButton: React.FC<Props> = ({
  icon,
  label,
  className,
  disabled,
  stopPropagation = true,
  variant = "danger",
  onClick,
  ...rest
}) => {
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    if (stopPropagation) e.stopPropagation();
    if (disabled) return;
    onClick?.(e);
  };

  return (
    <button
      type="button"
      className={`${styles.button} ${styles[variant]} ${className ?? ""}`}
      disabled={disabled}
      onClick={handleClick}
      {...rest}
    >
      {icon}
      {label && <span className={styles.label}>{label}</span>}
    </button>
  );
};